var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGreenCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22C0 9.8505 9.8505 0 22 0C34.144 0.0146667 43.9853 9.856 44 22C44 34.1495 34.1495 44 22 44C9.8505 44 0 34.1495 0 22Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 0C9.8505 0 0 9.8505 0 22C0 34.1495 9.8505 44 22 44C34.1495 44 44 34.1495 44 22C43.9853 9.856 34.144 0.0146667 22 0ZM34.6995 15.0333L22.1503 32.0632C21.5343 32.8808 20.372 33.044 19.5543 32.428C19.5452 32.4207 19.5378 32.4152 19.5287 32.4078L10.5673 25.2432C9.77717 24.6107 9.64883 23.4557 10.2813 22.6655C10.9138 21.8753 12.0688 21.747 12.859 22.3795L20.3317 28.358L31.7478 12.8645C32.3088 12.0212 33.4473 11.7938 34.2907 12.3548C35.134 12.9158 35.3613 14.0543 34.8003 14.8977C34.7673 14.9453 34.7343 14.9893 34.6995 15.0333Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M22 0C9.8505 0 0 9.8505 0 22C0 34.1495 9.8505 44 22 44C34.1495 44 44 34.1495 44 22C43.9853 9.856 34.144 0.0146667 22 0ZM34.6995 15.0333L22.1503 32.0632C21.5343 32.8808 20.372 33.044 19.5543 32.428C19.5452 32.4207 19.5378 32.4152 19.5287 32.4078L10.5673 25.2432C9.77717 24.6107 9.64883 23.4557 10.2813 22.6655C10.9138 21.8753 12.0688 21.747 12.859 22.3795L20.3317 28.358L31.7478 12.8645C32.3088 12.0212 33.4473 11.7938 34.2907 12.3548C35.134 12.9158 35.3613 14.0543 34.8003 14.8977C34.7673 14.9453 34.7343 14.9893 34.6995 15.0333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenCircleTick);
export default __webpack_public_path__ + "static/media/iconGreenCircleTick.fd3696f5f41d65be5c92465dc7a608ff.svg";
export { ForwardRef as ReactComponent };